exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wysiwyg-button {\r\n    border: 0;\n}\r\n", ""]);

// exports
